import { ThemeRegistryProps } from '@components/layout/providers/theme'

export const MUI_OPTIONS: ThemeRegistryProps['options'] = { key: 'mui' }
